import React, { useState, } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Card, Col, Container, Input, Label, Row, Button, FormFeedback, Form, Spinner, UncontrolledTooltip } from 'reactstrap';
import AuthSlider from '../authCarousel';
import { useDispatch } from "react-redux";
import '../../../assets/scss/pages/authCustem.scss';
import infoIcon from "../../../assets/images/i.png"

import withRouter from "../../../Components/Common/withRouter";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast, ToastContainer } from 'react-toastify';
import { loginUser } from 'live-slices/auth/login/thunk';
import emailTick from "../../../assets/images/email-tick.svg"
import SimpleBar from 'simplebar-react';


const CoverSignIn = (props: any) => {
    const dispatch: any = useDispatch();

    const [passwordShow, setPasswordShow] = useState<boolean>(false);
    const [loader, setLoader] = useState<boolean>(false);
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [selectedAccountType, setSelectedAccountType] = useState("personal");

    // const handleClick = () => {
    //     // Navigate to the OTP verification page
    //     navigate('/dashboard');
    // };

    const handleClick = async (data: any) => {
        loginUser({ ...data }, {});
        // Navigate to the OTP verification page
        // navigate('/dashboard');
    };

    const handleSignupType = (type: any) => {
        setSelectedAccountType(type);
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            userName: '',
            password: '',
        },
        validationSchema: Yup.object({
            userName: Yup.string()
                .required("Please Enter Your email address")
                .test(
                    "is-valid-email-or-phone",
                    selectedAccountType === "business"
                        ? "Phone number must start with '0' or '+92' and contain 10-12 digits."
                        : "Email must contain '@' and end with '.com'",
                    (value) =>
                        !value ||
                        (selectedAccountType === "business"
                            ? /^(0\d{10}|\+92\d{10})$/.test(value) // Phone number validation
                            : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) // Email validation
                        )
                ),

            password: Yup.string()
                .required("Please Enter Your Password"),
        }),

        onSubmit: async (values, { resetForm }) => {
            setLoader(true);
            try {
                await dispatch(loginUser({ ...values }, props.router.navigate));
            } catch (error) {
                setLoader(false);
            } finally {
                setLoader(false);
                resetForm();
            }
        }
    });


    const handleChangeOnlyPhoneCharacters = (e: any) => {
        const value = e.target.value.replace(/[^0-9+]/g, '');
        validation.setFieldValue('userName', value);
    };

    document.title = "Login";
    return (
        <React.Fragment>
            <ToastContainer />
            <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100 auth-form mobileScrolHight" >
                <div className="bg-overlay "></div>
                <div className="auth-page-content overflow-hidden ">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Card className="Specific-Class-for-border cardHightDv overflow-hidden">
                                    <Row className="g-0 h-100 resModile">
                                        <AuthSlider />
                                        <Col lg={6}  >
                                            <div className='d-flex justify-content-center align-items-center h-100' >
                                                <div className="height-of-login px-lg-5 px-4 py-2 mainBx">
                                                    <div className='resLoginDiv'>
                                                        <h1>Login</h1>
                                                        <p>Log in to manage your store, track orders, and grow your business.</p>
                                                    </div>
                                                    <div className=" selectDv selectDvMobileRes mb-2">
                                                        <div
                                                            className={`selectedDv ${selectedAccountType === "personal" ? "active" : ""}`}
                                                        >
                                                            <div className="d-flex gap-2">
                                                                <Input
                                                                    className="form-check-input cursor-pointer"
                                                                    type="radio"
                                                                    name="accountType"
                                                                    id="personalAccount"
                                                                    data-testing-Id="seller_selectuser"
                                                                    value="personal"
                                                                    onChange={() => handleSignupType("personal")}
                                                                    checked={selectedAccountType === "personal"}
                                                                />
                                                                <Label
                                                                    className="form-check-label d-flex align-items-center"
                                                                    htmlFor="personalAccount"
                                                                >
                                                                    Email
                                                                </Label>
                                                            </div>
                                                            <div>
                                                                <span
                                                                    style={{
                                                                        marginLeft: "10px",
                                                                        marginBottom: "5px",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    id="personal"
                                                                >
                                                                    <img src={infoIcon} alt="" height={14} width={14} />
                                                                </span>
                                                                <UncontrolledTooltip placement="top" target="personal">
                                                                    Email must contain '@' and end with '.com'
                                                                </UncontrolledTooltip>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className={`selectedDv ${selectedAccountType === "business" ? "active" : ""}`}
                                                        >
                                                            <div className="d-flex gap-2">
                                                                <Input
                                                                    className="form-check-input cursor-pointer"
                                                                    type="radio"
                                                                    name="accountType"
                                                                    id="businessAccount"
                                                                    data-testing-Id="otherPartner_selectuser"
                                                                    value="business"
                                                                    onChange={() => handleSignupType("business")}
                                                                    checked={selectedAccountType === "business"}
                                                                />
                                                                <Label className="form-check-label" htmlFor="businessAccount">
                                                                    Phone Number
                                                                </Label>
                                                            </div>
                                                            <div>
                                                                <span
                                                                    style={{
                                                                        marginLeft: "10px",
                                                                        marginBottom: "5px",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    id="business"
                                                                >
                                                                    <img src={infoIcon} alt="" height={14} width={14} />
                                                                </span>
                                                                <UncontrolledTooltip placement="top" target="business">
                                                                    Phone number must start with '0' or '+92'.
                                                                </UncontrolledTooltip>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="mt-4 fliedBox" >
                                                        <Form
                                                            onSubmit={(e) => {
                                                                e.preventDefault();
                                                                validation.handleSubmit();
                                                            }}
                                                        >
                                                            <div className="formContainer mobileResPass">
                                                                <label className="form-label" htmlFor="user-input">
                                                                    <span className="text-danger me-1">*</span> {selectedAccountType === "business" ? "Phone Number" : "Email Address"}
                                                                </label>
                                                                <Input
                                                                    name="userName"
                                                                    className="form-control leftPad"
                                                                    placeholder={selectedAccountType === "business" ? "Enter Phone Number (e.g., +92XXXXXXXXXX)" : "Enter Email"}
                                                                    data-testing-Id="userInput_login"
                                                                    type="text"
                                                                    onChange={selectedAccountType === "business" ? handleChangeOnlyPhoneCharacters : validation.handleChange}
                                                                    onBlur={validation.handleBlur}
                                                                    value={validation.values.userName || ""}
                                                                    invalid={validation.touched.userName && validation.errors.userName ? true : false}
                                                                />
                                                                {validation.touched.userName && validation.errors.userName ? (
                                                                    <FormFeedback type="invalid" className="">
                                                                        {validation.errors.userName}
                                                                    </FormFeedback>
                                                                ) : null}
                                                                <i className={`ri-${selectedAccountType === "business" ? "phone-line" : "mail-line"} text-secondary lefticonInfoDv`}></i>
                                                            </div>


                                                            <div className=" formContainer mobileResPass">
                                                                <label className="form-label" htmlFor="password-input"><span className="text-danger me-1">*</span> Password</label>
                                                                <div className="position-relative auth-pass-inputgroup ">
                                                                    <Input
                                                                        name="password"
                                                                        value={validation.values.password || ""}
                                                                        type={showPassword ? "text" : "password"}
                                                                        className="form-control leftPad"
                                                                        placeholder="Enter Password"
                                                                        data-testing-Id="passwordInput_login"
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        invalid={
                                                                            validation.touched.password && validation.errors.password ? true : false
                                                                        }
                                                                    />
                                                                    {validation.touched.password && validation.errors.password ? (
                                                                        <FormFeedback type="invalid" lassName='positoleft'>
                                                                            {validation.errors.password}
                                                                        </FormFeedback>
                                                                    ) : null}
                                                                    <button
                                                                        className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted shadow-none"
                                                                        onClick={() => setShowPassword(!showPassword)}
                                                                        type="button"
                                                                        id="password-addon"
                                                                        data-testing-Id="eyeIcon_login"
                                                                    >
                                                                        <i className="ri-eye-fill align-middle"></i>
                                                                    </button>
                                                                    <i className="bx bx-key text-secondary lefticonInfoDv"></i>
                                                                </div>
                                                            </div>

                                                            <div className=' d-flex justify-content-between align-items-center mobileResForget'>
                                                                <div className='d-flex justify-content-center align-items-center '>
                                                                    <Input aria-label="Checkbox for following text input" type="checkbox" className="form-check-input rounded-circle mt-0 me-2 form-check-input " value="" data-testing-Id="checkBoxInput_login" />
                                                                    <label className='m-0' > Remember Me</label>
                                                                </div>
                                                                <div className=''>
                                                                    <Link to="/forgot-password" className="text-muted mt-2" data-testing-Id="resetPassword_login">
                                                                        <p className='text-dark fs-6'><u>Forgot Password</u></p>
                                                                    </Link>
                                                                </div>
                                                            </div>

                                                            <div className='my-3' >
                                                                <Button
                                                                    color="secondary"
                                                                    disabled={loader}
                                                                    className=" w-100"
                                                                    type="submit"
                                                                    data-testing-Id="button_login"
                                                                >
                                                                    {loader && <Spinner size="sm" className="me-2"> Loading... </Spinner>}
                                                                    Login
                                                                </Button>

                                                            </div>

                                                            <div className=' text-center mobileSignUp 5'>
                                                                <p>Don't have an account
                                                                    <Link to="/register" className="text-muted mt-2 " data-testing-Id="creatAccount_login "><span className='text-secondary ms-1'>Sign up</span></Link>
                                                                </p>
                                                            </div>

                                                        </Form>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </React.Fragment>
    );
};

export default withRouter(CoverSignIn);